/* BFCM bottom bar: mount + live threshold updater
   - Mounts sticky bar (show + body padding + dismiss memory)
   - Countdown timer
   - Instant cart-driven threshold updates (only when right mode = threshold)
*/

(function () {
  const root =
    document.querySelector('#bfcm-bottom') ||
    document.querySelector('[data-bfcm-bottom]');
  if (!root) return;

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  // ====== MOUNT / SHOW ======================================================
  function mountBottomBar() {
    // respect "remember dismiss"
    const remember = root.getAttribute('data-remember') === 'true';
    const key = 'bfcmBottomDismissed';

    if (remember) {
      try {
        const v = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (v && Date.now() < v.until) return; // keep hidden
      } catch (e) {}
    }

    function applyPadding() {
      const h = root.getBoundingClientRect().height || 56;
      document.body.style.paddingBottom =
        'calc(' + h + 'px + env(safe-area-inset-bottom))';
    }

    // show the bar if hidden
    root.style.display = 'block';
    applyPadding();

    // close button
    const closeBtn = root.querySelector('.bfcm-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        root.style.display = 'none';
        document.body.style.paddingBottom = '';
        if (remember) {
          const hours = parseInt(root.getAttribute('data-remember-hours') || '12', 10);
          try {
            sessionStorage.setItem(
              key,
              JSON.stringify({ until: Date.now() + hours * 60 * 60 * 1000 })
            );
          } catch (e) {}
        }
      });
    }

    // keep padding correct on resize
    window.addEventListener('resize', applyPadding);
  }

  // ====== COUNTDOWN TIMER (America/Toronto) ================================
  function initCountdown() {
    const timer = root.querySelector('#bfcm-timer');
    if (!timer) return; // timer removed in Liquid when disabled

    const year = parseInt(timer.dataset.year, 10);
    const month = parseInt(timer.dataset.month, 10);
    const day = parseInt(timer.dataset.day, 10);
    const hour = parseInt(timer.dataset.hour, 10);
    const minute = parseInt(timer.dataset.minute, 10);

    if (!year || !month || !day) return;

    const showDays = timer.dataset.showDays === 'true';
    const showHours = timer.dataset.showHours === 'true';
    const showMinutes = timer.dataset.showMinutes === 'true';
    const showSeconds = timer.dataset.showSeconds === 'true';

    const endLabel = root.getAttribute('data-end-label') || 'Sale Has Ended';
    const labelEl = root.querySelector('[data-bfcm-label]');

    // Toronto standard time (UTC-5) for late Nov / winter
    const targetTs = new Date(
      `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(
        2,
        '0'
      )}T${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}:00-05:00`
    ).getTime();

    const daysCol = timer.querySelector('[data-unit="days"]');
    const hoursCol = timer.querySelector('[data-unit="hours"]');
    const minutesCol = timer.querySelector('[data-unit="minutes"]');
    const secondsCol = timer.querySelector('[data-unit="seconds"]');

    const daysNum = timer.querySelector('[data-bfcm-days]');
    const hoursNum = timer.querySelector('[data-bfcm-hours]');
    const minutesNum = timer.querySelector('[data-bfcm-minutes]');
    const secondsNum = timer.querySelector('[data-bfcm-seconds]');

    function setColumn(colEl, numEl, value, show) {
      if (!colEl || !numEl) return;
      if (!show) {
        colEl.style.display = 'none';
        return;
      }
      colEl.style.display = '';
      numEl.textContent = value;
    }

    function updateCountdown() {
      const now = Date.now();
      const diff = targetTs - now;

      if (diff <= 0) {
        clearInterval(interval);
        if (labelEl) labelEl.textContent = endLabel;
        timer.style.display = 'none';
        return;
      }

      let totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / (60 * 60 * 24));
      totalSeconds -= days * 60 * 60 * 24;
      const hours = Math.floor(totalSeconds / (60 * 60));
      totalSeconds -= hours * 60 * 60;
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds - minutes * 60;

      setColumn(daysCol, daysNum, String(days), showDays);
      setColumn(hoursCol, hoursNum, String(hours).padStart(2, '0'), showHours);
      setColumn(minutesCol, minutesNum, String(minutes).padStart(2, '0'), showMinutes);
      setColumn(secondsCol, secondsNum, String(seconds).padStart(2, '0'), showSeconds);
    }

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
  }

  // ====== THRESHOLD LOGIC ===================================================
  // Decide mode once. If not threshold mode, do nothing (prevents overriding custom text).
  const rightMode = root?.dataset?.rightMode || 'threshold';
  const thresholdNode = root.querySelector('[data-bfcm-text]');
  const shouldRunThreshold = rightMode === 'threshold' && !!thresholdNode;

  const TIERS = [100, 200, 300, 400];
  const MAX_TIER = TIERS[TIERS.length - 1];
  const EXCLUDE_TITLES = ['TSR Package Protection'];

  const moneyFmt = (amount, currency) =>
    new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount);

  const isUS = () => {
    if (window.Shopify && Shopify.country) return Shopify.country === 'US';
    const htmlCountry = document.documentElement.getAttribute('data-country');
    if (htmlCountry) return htmlCountry === 'US';
    return false;
  };
  const presentCurrency = () => (isUS() ? 'USD' : 'CAD');

  const debounce = (fn, ms) => {
    let t;
    return function () {
      clearTimeout(t);
      const args = arguments,
        ctx = this;
      t = setTimeout(() => fn.apply(ctx, args), ms);
    };
  };

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { 'Cache-Control': 'no-cache' } });
    if (!res.ok) throw new Error('Cart fetch failed');
    return res.json();
  }

  function computeEligibleSubtotal(cart) {
    let cents = 0;

    for (const it of cart.items) {
      const title = (it.product_title || it.title || '').trim();
      const excludeByTitle = EXCLUDE_TITLES.some((x) => title.indexOf(x) !== -1);
      const isGiftCard =
        !!it.gift_card || (it.product_type || '').toLowerCase() === 'gift card';
      if (excludeByTitle || isGiftCard) continue;

      let lineCents;
      if (typeof it.original_line_price === 'number' && it.original_line_price > 0) {
        lineCents = it.original_line_price;
      } else if (typeof it.original_price === 'number' && it.original_price > 0) {
        lineCents = it.original_price * it.quantity;
      } else {
        lineCents = (it.price ?? it.final_price) * it.quantity;
      }

      cents += lineCents;
    }

    return cents / 100;
  }

  function nextTierInfo(subtotal) {
    let current = 0,
      next = null,
      pct = 0;
    for (const t of TIERS) {
      if (subtotal >= t) current = t;
      else {
        next = t;
        break;
      }
    }
    if (next === null) pct = 100;
    else pct = Math.max(0, Math.min(100, (subtotal / MAX_TIER) * 100));
    return { current, next, pct };
  }

  function render(subtotal) {
    const { next, pct } = nextTierInfo(subtotal);
    const currency = presentCurrency();
    const DISCOUNT = { 100: 10, 200: 20, 300: 30, 400: 40 };

    let text;
    if (next === null) {
      text = 'Top Discount Unlocked: 40% OFF';
    } else {
      const diff = Math.max(0, next - subtotal);
      text = `${moneyFmt(diff, currency)} AWAY FROM ${DISCOUNT[next]}% OFF`;
    }

    const el = root.querySelector('[data-bfcm-text]');
    if (el) el.textContent = text;

    // (no progress bar, but keep safe if present)
    $$('.bfcm-fill, [data-bfcm-fill]', root).forEach((fill) => {
      fill.style.width = `${pct}%`;
    });
  }

  async function updateThreshold() {
    if (!shouldRunThreshold) return;
    try {
      const cart = await fetchCart();
      const subtotal = computeEligibleSubtotal(cart);
      render(subtotal);
    } catch (e) {
      console?.warn?.('[BFCM Threshold] update failed:', e);
    }
  }

  const updateNow = () => updateThreshold();
  const updateSoon = debounce(updateThreshold, 120);

  function wireEvents() {
    if (!shouldRunThreshold) return;

    document.addEventListener('cart:updated', updateSoon);
    document.addEventListener('cart:change', updateSoon);

    window.Shopify = window.Shopify || {};
    const originalOnItemAdded = Shopify.onItemAdded;
    Shopify.onItemAdded = function () {
      updateNow();
      if (typeof originalOnItemAdded === 'function')
        originalOnItemAdded.apply(this, arguments);
    };

    const originalOnCartUpdate = Shopify.onCartUpdate;
    Shopify.onCartUpdate = function () {
      updateSoon();
      if (typeof originalOnCartUpdate === 'function')
        originalOnCartUpdate.apply(this, arguments);
    };

    document.body.addEventListener(
      'submit',
      (e) => {
        const form = e.target.closest('form[action*="/cart/add"]');
        if (!form) return;
        setTimeout(updateSoon, 150);
        setTimeout(updateSoon, 450);
      },
      true
    );

    document.body.addEventListener('click', (e) => {
      const el = e.target.closest(
        '[name="remove"],[data-ajax-cart-remove],[data-cart-remove],.js-qty__adjust,.quantity__button,.cart-remove-button'
      );
      if (el) {
        setTimeout(updateSoon, 120);
        setTimeout(updateSoon, 500);
      }
    });

    document.body.addEventListener('change', (e) => {
      const q = e.target.closest(
        'input[name^="updates"], .quantity__input, input[name="quantity"]'
      );
      if (q) {
        setTimeout(updateSoon, 120);
        setTimeout(updateSoon, 500);
      }
    });

    window.addEventListener('message', (ev) => {
      if (!ev || !ev.data) return;
      const t = ev.data.type || ev.data.event;
      const s = ('' + t).toLowerCase();
      if (s.includes('rebuy') && s.includes('cart')) updateSoon();
    });
    document.addEventListener('rebuy:cart.change', updateSoon);
    document.addEventListener('rebuy:cart.add', updateSoon);
    document.addEventListener('rebuy:cart.remove', updateSoon);

    const drawer = document.querySelector('.cart-drawer, #CartDrawer, [data-cart-drawer]');
    if (drawer) {
      const mo = new MutationObserver(updateSoon);
      mo.observe(drawer, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateNow);
    } else {
      updateNow();
    }
  }

  // public hook (only when threshold mode)
  window.BFCM = window.BFCM || {};
  if (shouldRunThreshold) window.BFCM.updateThreshold = updateNow;

  // ====== INIT ==============================================================
  function initBfcmBar() {
    mountBottomBar();
    initCountdown();
    wireEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBfcmBar);
  } else {
    initBfcmBar();
  }
})();
